import React from 'react';
import propTypes from 'prop-types';
import {get} from 'lodash';
import styled from 'styled-components';
import {TextField} from '@material-ui/core';
import {Controller} from "react-hook-form";
import {phoneRegex} from '../../../../util/regex';
import {theme} from '../../../../themes/default-theme';
import isEmail from 'validator/lib/isEmail';

const FormItem = styled.div`
  display: block;
  margin:${props => props.margin === 'none' ? `0` : `30px 0`};
  width: 100%;
  text-align: left;

  ${props => props.display === 0 && `
    display: none;
  `}
`

const Error = styled.p`
  color: ${theme.palette.error.form}
`

const Step3 = ({formProps, state}) => {

  const {
    control,
    errors
  } = formProps

  const textFieldProps = {
    as:TextField,
    control:control,
    rules:{required: true },
    variant:"outlined",
    fullWidth: true,
    defaultValue: ''
  }

  return (
    <>
      {/* First name */}
      <FormItem>
        <Controller
          {...textFieldProps}
          name={'first_name'}
          placeholder={'First name*'}
          error={get(errors, `[first_name]`, false) ? true : false}
          defaultValue={state.first_name || ''}
        />
        {get(errors, `[first_name]`, false) && <Error>This field is required</Error>}

      </FormItem>
      {/* Last name */}
      <FormItem>
        <Controller
          {...textFieldProps}
          name={'last_name'}
          placeholder={'Last name*'}
          error={get(errors, `[last_name]`, false) ? true : false}
          defaultValue={state.last_name || ''}
        />
        {get(errors, `[last_name]`, false) && <Error>This field is required</Error>}
      </FormItem>
      {/* Email */}
      <FormItem>
        <Controller
          {...textFieldProps}
          type="email"
          name={'email'}
          placeholder={'Email*'}
          error={get(errors, `[email]`, false) ? true : false}
          defaultValue={state.email || ''}
          rules={{
            required: true,
            type: 'custom',
            validate: isEmail
          }}
        />
        {get(errors, `[email]`, false) && <Error>Please add a valid email address</Error>}
      </FormItem>
      {/* Contact number */}
      <FormItem>
        <Controller
          {...textFieldProps}
          type="tel"
          rules={{
            ...textFieldProps.rules,
            type: 'custom',
            minLength: 8,
            maxLength: 13
          }}
          name={'phone'}
          placeholder={'Contact number*'}
          error={get(errors, `[phone]`, false) ? true : false}
          defaultValue={state.phone || ''}
        />
        {get(errors, `[phone]`, false) && <Error>Please add a valid phone number</Error>}
      </FormItem>

    </>
  )
}
  
Step3.propTypes = {
}
  
Step3.defaultProps = {
}
  
export default Step3